import en from "./translations/en.json"

export const messages = {
  source_selection: {
    title: en.select_capture_option,
    camera_permissions_warning: {
      title: en.camera_access_denied,
      instructions_reset: en.update_camera_permissions_or_upload,
      instructions_reload: en.update_camera_permissions_or_upload,
    },
    camera_video: en.take_photo,
    upload_photo: en.upload_from_device,
  },
  face_live_video: {
    face_displaced: en.place_face_inside_frame,
    face_placement_fixed: en.perfect,
    face_distance_far: en.move_closer,
    face_distance_close: en.move_further_away,
    face_distance_fixed: en.perfect,
    face_angle_deviation: en.turn_face_to_camera,
    face_angle_fixed: en.perfect,
    lighting_insufficient: en.find_brighter_place,
    lighting_excessive: en.find_darker_place,
    lighting_angle_deviation: en.turn_to_light_source,
    lighting_fixed: en.perfect,
    capturing: en.look_at_the_camera,
  },
  face_180_live_video: {
    face_displaced: en.place_face_inside_frame,
    face_placement_fixed: en.perfect,
    face_distance_far: en.move_closer,
    face_distance_close: en.move_further_away,
    face_distance_fixed: en.perfect,
    face_angle_deviation: en.turn_face_to_camera,
    face_angle_fixed: en.perfect,
    lighting_insufficient: en.find_brighter_place,
    lighting_excessive: en.find_darker_place,
    lighting_angle_deviation: en.turn_to_light_source,
    lighting_fixed: en.perfect,
    rotating_left: en.move_your_head_slowly_to_scan_your_skin,
    rotating_right: en.move_your_head_slowly_to_scan_your_skin,
    capturing_front: en.stay_still,
    capturing_left: en.stay_still,
    capturing_right: en.stay_still,
    capturing_done: en.perfect,
  },
  hair_live_video: {
    face_displaced: en.place_face_inside_frame,
    face_placement_fixed: en.perfect,
    face_distance_close: en.move_further_away,
    face_distance_fixed: en.perfect,
    lighting_insufficient: en.find_brighter_place,
    lighting_fixed: en.perfect,
    hair_not_visible: en.make_hair_visible,
    hair_visibility_fixed: en.perfect,
    face_angle_deviation: en.turn_face_to_camera,
    face_angle_fixed: en.perfect,
    capturing: {
      manual: en.make_hair_visible_photo_manual,
      auto: en.make_hair_visible_photo_auto,
    },
  },
  preview: {
    title: en.well_done,
    retake: en.retake,
    submit: en.submit,
  },
  error: {
    title: en.ooops,
    description: en.video_failed_use_upload,
  },
}
